import useUrl from './helpers/useUrl'

/**
 * @param {import('@nuxtjs/axios').NuxtAxiosInstance} client
 * */
export default (client) => {
  const root = useUrl('lootboxes')
  
  return {
    getCampaignList() {
      const url = root('campaigns-list')
      return client.get(url)
    },
    getList() {
      const url = root('list')
      return client.get(url)
    },
    open({ lootboxUuid }) {
      const url = root('open')
      return client.post(url, { lootboxUuid })
    },
  }
}
